import { render, staticRenderFns } from "./drawerFiles.vue?vue&type=template&id=04ebe23d&"
import script from "./drawerFiles.vue?vue&type=script&lang=js&"
export * from "./drawerFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports